import {Ability} from '~/lib/ability';

export class PaymentsAbility extends Ability {
    canCreate = () => this.isAdmin();
    canChangeStatus = () => this.isAdmin() || this.isManager();
    canViewTransactionHistory = () => this.isAdmin() || this.isManager();
}
